import { useAtom } from "@reatom/npm-react";
import { PriceDtoCurrencyEnum } from "definitions/product-storage";
import {
  useQueryParams,
  StringParam,
  NumberParam,
  ArrayParam,
} from "use-query-params";

import { filterAtom } from "../store/atoms/filterQuery";
import { ProductFilters } from "../widgets/ProductFilters/ProductFilters";

export const useProductFilters = () => {
  const [filter, setFilter] = useAtom(filterAtom);

  const [, setQuery] = useQueryParams({
    search: StringParam,
    currency: StringParam,
    brandIds: ArrayParam,
    categoryIds: ArrayParam,
    priceFrom: NumberParam,
    priceTo: NumberParam,
    viewAllSelected: StringParam,
    genders: ArrayParam,
    sources: ArrayParam,
    includeCustom: StringParam,
    excludeSamples: ArrayParam,
  });

  const updateFilters = (newFilters: Partial<ProductFilters>) => {
    const updatedFilters = { ...filter, ...newFilters };
    setFilter(updatedFilters);

    setQuery({
      search: updatedFilters.search || undefined,
      currency: updatedFilters.currency || PriceDtoCurrencyEnum.Rub,
      brandIds: updatedFilters.brandIds?.map(String) || undefined,
      categoryIds: updatedFilters.categoryIds?.map(String) || undefined,
      priceFrom: updatedFilters.priceFrom || undefined,
      priceTo: updatedFilters.priceTo || undefined,
      viewAllSelected: updatedFilters.viewAllSelected ? "true" : undefined,
      includeCustom:
        updatedFilters.includeCustom !== undefined
          ? String(updatedFilters.includeCustom)
          : undefined,
      genders: updatedFilters.genders?.map(String) || undefined,
      sources: updatedFilters.sources?.map(String) || undefined,
      excludeSamples: updatedFilters.excludeSamples?.map(String) || undefined,
    });
  };

  return {
    filter,
    updateFilters,
  };
};
